/*export function createElement(tag, className = '', textContent = '') {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (textContent) element.textContent = textContent;
    return element;
}*/

export function activateCardLinks(){
    const internalLinks = document.querySelectorAll('.Tag__top a, .Authors a');

    internalLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
            event.stopPropagation();
        });
    });
}
